var map = {
	"./bbc54yyk/logo.svg": 933,
	"./chaoxinxing/logo.svg": 935,
	"./ecshopx/logo.svg": 937,
	"./onex/logo.svg": 944,
	"./yyk/logo.svg": 946
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;


//////////////////
// WEBPACK FOOTER
// ./static/img ^\.\/.*\/logo\.svg$
// module id = 43
// module chunks = 30